//
// Copyright 2021 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import {makeStyles} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ModuleTreeView from "src/components/loader/tree/ModuleTreeView";
import Paper from "@material-ui/core/Paper";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  textField: {
    width: "100%",
  },
  error: {
    color: "red",
  },
  checkbox: {
    paddingLeft: 0,
  },
  paper: {
    padding: 10,
  },
  button: {
    margin: 4,
  },
  expandablePanelIcon: {
    margin: 4,
  },
  expandablePanel: {
    paddingLeft: 10,
  },
}));
const ModuleOptionsPage = ({navigateToResults}) => {
  const classes = useStyles();

  return (
    <React.Fragment>
      <div>
        <Typography variant="body2" color="textSecondary">
          <h5>Automation Modules Option</h5>
          <hr/>
        </Typography>

        <div>
          <Paper className={classes.paper}>
            <Typography variant="body2" color="textSecondary">
              <h6>Customize the module columns</h6>
            </Typography>
            <Typography variant="caption" color="textSecondary">
              Use this area to customize the columns included in the extraction of the modules where such customization is possible. You can
              also customize the columns in the [Extract] page. It is possible to also define a list of UDFs that will be used to match existing
              resource assignments in the ResourceAssignment module - which is useful if you have duplicates. Please remember that the
              options here are saved in your configuration definition, accessible via the button [Save & Load Definitions] at the bottom of this page.
            </Typography>
            <div className={classes.paper}>
              <ModuleTreeView path={"loader:extract:modules"} showCheckBoxes={false} editableOnly={true}/>
            </div>
          </Paper>
        </div>
      </div>
    </React.Fragment>
  );
};
export default ModuleOptionsPage;
